module.exports = __webpack_public_path__ + "static/media/5.16_preview.11e83024.png";